var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEllipsisVSolid = function SvgEllipsisVSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 36.546c7.437 0 13.454 6.017 13.454 13.454S57.437 63.454 50 63.454 36.546 57.437 36.546 50 42.563 36.546 50 36.546zM36.546 17.113c0 7.437 6.017 13.454 13.454 13.454s13.454-6.017 13.454-13.454S57.437 3.659 50 3.659 36.546 9.676 36.546 17.113zm0 65.774c0 7.437 6.017 13.454 13.454 13.454s13.454-6.017 13.454-13.454S57.437 69.433 50 69.433 36.546 75.45 36.546 82.887z",
    fill: "currentColor"
  })));
};
export default SvgEllipsisVSolid;